/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Group, Icon } from '@insticator/insticator-ui'; // iui-material
import ProgressBar from 'material/embeds/progressbar/progressbar';



/* ========== ~~~~~~~~~~ EMBED : CONTENT ANALYTICS CARD : QUESTIONBASED ~~~~~~~~~~ ========== */
const QuestionBasedContentAnalyticsCard = props => {
    const options = Object.assign([], props.contentDetail.options);

    const renderOptions = () => options.map((option, index) => renderOption(option, index));

    const renderOption = (option, index) => (
        <div key={index} className={`answer ${option.optionUUID} ${props.content.contentType} ${props.contentDetail.type}`}>
            {renderOptionVisual(option)}
            <div className={`info`}>
                <div className={`details bold-${isTopAnswered(index)}`}>
                    <div className={`text`}>{renderOptionText(option)}{renderCorrectIcon(option)}</div>
                    <div className={`answerednumber`}>{option.numOfTimesChosen}</div>
                </div>
                <ProgressBar foreground={handleBarColor(isTopAnswered(index))} fill={`${getOptionPercentage(option)}%`}/>
            </div>
        </div>
    );

    const renderOptionText = option => isTextualOption() ? option.text : null;

    const isTextualOption = () => ['text1', 'text2', 'image1'].includes(props.contentDetail.type);

    const renderOptionVisual = option => (
        <div className={`visual`}>
            {renderTypeSpecificVisual(option)}
        </div>
    );

    const renderTypeSpecificVisual = option => {
        switch(props.contentDetail.type) {
            case 'emoji':
                return <div className={`emoji`}>{!!option.emoji ? option.emoji : '👻'}</div>;
            case 'image1':
            // fall through
            case 'image2':
                return option.imageURL && <div className={`image`} style={{backgroundImage: `url(${option.imageURL})`}}/>
            default:
                return null;
        }
    };

    const isCorrectOption = option => props.content.contentType === 'quiz' && option.correctOption;

    const isTopAnswered = optionIndex => optionIndex === topSelectedOptionIndex;

    const getOptionPercentage = option => typeof props.contentDetail.totalNumberAnswered === 'number' &&
        props.contentDetail.totalNumberAnswered !== 0 &&
        typeof option.numOfTimesChosen === 'number' ?
            Math.round((option.numOfTimesChosen / props.contentDetail.totalNumberAnswered) * 100) : 0;

    const getMostlySelectedOptionIndex = () => {
        let highestNumOfTimesChosen = 0;
        let mostlySelectedOptionIdx = null;
        options.forEach((option, index) => {
            if ((option.numOfTimesChosen > highestNumOfTimesChosen)) {
                highestNumOfTimesChosen = option.numOfTimesChosen;
                mostlySelectedOptionIdx = index;
            }
        });
        return mostlySelectedOptionIdx;
    };

    const renderCorrectIcon = option => isCorrectOption(option) ? (
        <div className={`correct-answer`}>
            <Icon name={`check`}/> Correct answer
        </div>
    ) : null;

    const topSelectedOptionIndex = getMostlySelectedOptionIndex();

    const handleBarColor = isMostlySelected => isMostlySelected ? '#1494f4' : '#A2C2DA';

    return (
        <Group name={`content`}>
            <div className={`question`}>{props.contentDetail.title}</div>
            <div className={`answers`}>{renderOptions()}</div>
        </Group>
    )
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default QuestionBasedContentAnalyticsCard;
